export default "__VITE_ASSET__CMgYu40u__"